<template>
    <section class="section collection pb-0">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12">
                    <div class="section__header wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                        <h2 class="h3">Browse high-resolution photo collections</h2>
                    </div>
                </div>
            </div>
            <div class="row items-gap col-grd">
                <div class="col-12 col-lg-4 col-xl-4">
                    <div class="coll-single">
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/one.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/two.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/three.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/four.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/five.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/six.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/seven.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-4 col-xl-4">
                    <div class="coll-single">
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/eight.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/nine.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/ten.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/eleven.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/twelve.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/thirteen.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-4 col-xl-4">
                    <div class="coll-single">
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/fourteen.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/fifteen.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/sixteen.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/seventeen.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/eighteen.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/nineteen.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                            <img :src="require('@/assets/images/home-seven/twenty.png')" alt="Image">
                            <div class="content">
                                <p class="h5">The dog is a domesticated</p>
                                <div class="foot-wrap">
                                    <div class="foot">
                                        <span>
                                            Download: 2.4K
                                        </span>
                                        <button>
                                            <i class="fa-solid fa-heart"></i>
                                        </button>
                                        <button>
                                            <i class="fa-solid fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="collection-cta text-center">
                        <button class="btn btn-fo">Load More</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Collection",
    }
</script>


// WEBPACK FOOTER //
// src/components/page_components/home-7/Collection.vue